/**
 * 注入 51la 异步统计脚本
 * @param id - 51la Site ID（同时作为 id 和 ck）
 */
export function injectLA(id: string): void {
  if (!id) return;
  if (document.getElementById('LA_COLLECT')) return;
  const win = window as any;
  const p: any = { id, ck: id };
  const src = (location.protocol === 'https:' ? 'https://' : 'http://') + 'sdk.51.la/js-sdk-pro.min.js';
  const n = document.createElement('script');
  const r = document.getElementsByTagName('script')[0];
  n.type = 'text/javascript';
  n.setAttribute('charset', 'UTF-8');
  n.async = true;
  n.src = src;
  n.id = 'LA_COLLECT';
  p.d = n;
  const push = () => win.LA.ids.push(p);
  if (win.LA) {
    win.LA.ids && push();
  } else {
    win.LA = p;
    win.LA.ids = [];
    push();
  }
  r.parentNode!.insertBefore(n, r);
}

/**
 * 从后端公开接口拉取统计配置并注入对应站点的脚本
 */
export async function initAnalytics(site: 'web' | 'h5' | 'courier_h5'): Promise<void> {
  try {
    const res = await fetch('/api/public/analytics-config');
    const json = await res.json();
    if (json.code === 0 && json.data?.[site]) {
      injectLA(json.data[site]);
    }
  } catch {
    // 统计脚本加载失败不影响主功能
  }
}
